export default __webpack_public_path__ + "static/dentastar-9e658854ed9d7cbdac59c3a6648fbf45.png";